import { render } from "./ToolbarComponent.vue?vue&type=template&id=6bf3d364&scoped=true"
import script from "./ToolbarComponent.vue?vue&type=script&lang=js"
export * from "./ToolbarComponent.vue?vue&type=script&lang=js"

import "./ToolbarComponent.vue?vue&type=style&index=0&id=6bf3d364&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf3d364"]])

export default __exports__